exports = module.exports = require("/Users/kirill/projects/hexlet-ide/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".icon-folder, .icon-file { margin-right: 0.75em; }\n\n.terminals-box {\n    /* height: 40%; */\n}\n\n.terminal {\n    width: 100%;\n    /* height: 100%; */\n}\n\n.tree {\n    /* height: 100%; */\n}\n\n.tabs-box {\n    height: 60%;\n}\n\n.file-tree-box {\n    height: 60%;\n}\n\n.loader {\n    margin: auto;\n}\n", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/editor/styles/application.css
 ** module id = 16
 ** module chunks = 0
 **/